function findPasswordField(e) {
    //find element wrapping svg
    var showHideIcon = e.target.closest('[data-show-hide]');
    if (showHideIcon) {
        showHideIcon.classList.remove('single-heartbeat')
        //hack to make sure the css class has been removed
        setTimeout(function () {
            //find element to change type
            var passwordField = showHideIcon.parentElement.querySelector('[data-show-hide-this]');
            if (passwordField) {
                passwordField.type = (passwordField.type == 'password')? 'text':'password'
            }
            // find svg
            var svg = showHideIcon.querySelector('use')
            if (svg) {
                var svgURL = svg.href.baseVal;
                //split the svg path to get what icon is used
                var svgArray = svgURL.split('-')
                if (svgArray.length > 0) {
                    //rewrite the svg icon path
                    var icon = (svgArray[1] == 'eye') ? 'hide' : 'eye';
                    svg.href.baseVal = svgArray[0] + '-' + icon
                    showHideIcon.classList.add('single-heartbeat')
                }
            }
        }, 0)
    }
    
}
document.addEventListener('click', findPasswordField)